exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ndiv[data-v-2ebca594] .message {\r\n    display:block;\r\n    margin-bottom: 30px;\r\n    font-size:15px;\r\n    font-weight: 600;\r\n    color:#444;\n}\r\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Laxit/NotesModal.vue"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,WAAW;CACd","file":"NotesModal.vue","sourcesContent":["\ndiv[data-v-2ebca594] .message {\r\n    display:block;\r\n    margin-bottom: 30px;\r\n    font-size:15px;\r\n    font-weight: 600;\r\n    color:#444;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ebca594","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Laxit/NotesModal.vue
// module id = 2097
// module chunks = 0